import "./styles/main.css";
import { Router } from "./shared/router/Router.js";
import { AccesoController } from "./acceso/AccesoController.js";

// Ingreso directo desde otra app ya autenticada:
//   /?legajo=1234&dni=30111222   (alias: l / documento, doc, d)
// Se lee del query string (no del hash) y se limpia de la URL para no dejar
// legajo/DNI en el historial.
function leerIngresoDirecto() {
  const params = new URLSearchParams(window.location.search);
  const legajo = (params.get("legajo") || params.get("l") || "").trim();
  const dni = (params.get("dni") || params.get("documento") || params.get("doc") || params.get("d") || "").trim();
  if (!legajo || !dni) return null;
  return { legajo, dni };
}

const initApp = async () => {
  const router = new Router();
  const directo = leerIngresoDirecto();

  if (directo) {
    history.replaceState(null, "", window.location.pathname);
    // Valida y deja la sesion iniciada. Si falla, AccesoController guarda el
    // mensaje para mostrarlo en #acceso. replaceState no dispara hashchange,
    // asi que el router renderiza una sola vez en init().
    const ok = await AccesoController.ingresoDirecto(directo);
    history.replaceState(null, "", window.location.pathname + (ok ? "#vacaciones" : "#acceso"));
  }

  router.init();
};

document.addEventListener("DOMContentLoaded", initApp);
